import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

export default function NewsSection() {
  const news = latestArticles(6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="news-title">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs md:text-sm text-primary-500 font-medium tracking-widest mb-2">LATEST NEWS</p>
            <h2 id="news-title" className="font-heading text-2xl md:text-3xl text-foreground-950">最新动态</h2>
          </div>
          <Link
            to="/category/news"
            className="flex items-center gap-1.5 text-sm text-secondary-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2.5 py-0.5 rounded-full">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}